import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchContenusByModule = createAsyncThunk(
  "contenus/fetchByModule",
  async (moduleId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/contenus/module/${moduleId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const createContenu = createAsyncThunk(
  "contenus/create",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post("/contenus", formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur création");
    }
  }
);

export const updateContenu = createAsyncThunk(
  "contenus/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(`/contenus/${id}`, formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur modification");
    }
  }
);

export const deleteContenu = createAsyncThunk(
  "contenus/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/contenus/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur suppression");
    }
  }
);

const contenuSlice = createSlice({
  name: "contenus",
  initialState: { list: [], loading: false, error: null, success: null, total: 0, page: 1, pages: 1 },
  reducers: {
    clearContenuMessages: (state) => { state.error = null; state.success = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContenusByModule.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(fetchContenusByModule.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
        state.total = action.payload.total ?? state.list.length;
        state.page = action.payload.page ?? 1;
        state.pages = action.payload.pages ?? 1;
      })
      .addCase(fetchContenusByModule.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createContenu.fulfilled, (state, action) => {
        state.list.push(action.payload);
        state.success = "Contenu créé avec succès.";
      })
      .addCase(createContenu.rejected, (state, action) => { state.error = action.payload; })
      .addCase(updateContenu.fulfilled, (state, action) => {
        const idx = state.list.findIndex((c) => c._id === action.payload._id);
        if (idx !== -1) state.list[idx] = action.payload;
        state.success = "Contenu mis à jour.";
      })
      .addCase(updateContenu.rejected, (state, action) => { state.error = action.payload; })
      .addCase(deleteContenu.fulfilled, (state, action) => {
        state.list    = state.list.filter((c) => c._id !== action.payload);
        state.success = "Contenu supprimé.";
      })
      .addCase(deleteContenu.rejected, (state, action) => { state.error = action.payload; });
  },
});

export const { clearContenuMessages } = contenuSlice.actions;
export default contenuSlice.reducer;
